export function getListPayload(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.list)) {
    return data.list;
  }
  return [];
}
